export const POI_MIN_RADIUS = 1;
export const POI_MAX_RADIUS = 20000;
export const POI_DEFAULT_RADIUS = 100;

export const DEFAULT_PANEL_LIST_ITEM_SIZE_PX = 48;
export const WITH_RADIUS_INPUT_ITEM_SIZE_PX = 130;

export const MAX_VISIBLE_SAME_POI_CATEGORY_CHIPS_BEFORE_COMPRESSION = 5;

export const MAX_NUMBER_OF_ALLOWED_POIS = 5;

export const CUSTOM_POI_MAX_FILES = 2;
export const CUSTOM_POI_MAX_ROWS = 5000;
export const CUSTOM_POI_DATA_PROVIDER = 'Custom POI';
